var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-warp"},[_c('span',[_vm._v(_vm._s(_vm.dateTxt))]),_c('div',{staticClass:"wh-flex-between"},[_c('span',[_vm._v(_vm._s(_vm.dateTime))]),_c('span',[_vm._v("星期"+_vm._s(_vm.dateDay))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }